import { render, staticRenderFns } from "./DocumentTableRow.vue?vue&type=template&id=789c6174&scoped=true&lang=html"
import script from "./DocumentTableRow.vue?vue&type=script&lang=js"
export * from "./DocumentTableRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentTableRow.vue?vue&type=style&index=0&id=789c6174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c6174",
  null
  
)

export default component.exports